import * as Yup from "yup";

/**
 * Validation shared by the Add and Update forms, so both enforce the same rule
 * rather than drifting apart.
 *
 * A standard answered "Yes" is a claim that the partner meets it, so it must be
 * backed by at least one supporting document. "No" and "Not applicable" hide
 * the upload entirely and are checked against `meetsStandard === true`, which
 * is only ever set by "Yes" — a standard marked not applicable carries
 * `meetsStandard: null`, so the rule does not reach it.
 */
export const SUPPORTING_DOCUMENT_REQUIRED =
  "Attach at least one supporting document for a standard marked “Yes”.";

export const coreStandardsValidationSchema = Yup.array().of(
  Yup.object({
    selectedFiles: Yup.array().when("meetsStandard", {
      is: (meetsStandard: any) => meetsStandard === true,
      then: (schema) => schema.min(1, SUPPORTING_DOCUMENT_REQUIRED),
      otherwise: (schema) => schema,
    }),
  })
);

/**
 * Reads the per-standard file error out of Formik's nested array errors.
 * Returns undefined when the standard is fine.
 */
export const supportingDocumentError = (
  errors: any,
  index: number
): string | undefined => {
  const entry = Array.isArray(errors?.coreStandards)
    ? errors.coreStandards[index]
    : undefined;
  return typeof entry?.selectedFiles === "string"
    ? entry.selectedFiles
    : undefined;
};

/** Indexes of the standards currently failing the supporting-document rule. */
export const standardsMissingDocuments = (errors: any): number[] => {
  const list = Array.isArray(errors?.coreStandards) ? errors.coreStandards : [];
  return list.reduce((acc: number[], entry: any, index: number) => {
    if (entry?.selectedFiles) acc.push(index);
    return acc;
  }, []);
};
